module.exports = __webpack_public_path__ + "img/sidebar-logo.20c2c25b.png";